import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { EventLoggerService } from '@services/event-logger-service';
import { AppConfig } from 'client/app/app.config';

@Component({
  selector: 'multi-product-selection-sheet',
  templateUrl: './multi-product-selection-sheet.html',
  styleUrls: [],
  standalone: false,
})
export class MultiProductSelectionSheetComponent implements OnInit {
  selectedProducts: string[] = [];
  // eslint-disable-next-line new-cap
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public appConfig: AppConfig,
    private bottomSheetRef: MatBottomSheetRef,
    private eventLogger: EventLoggerService,
  ) {}

  ngOnInit(): void {
    this.addTrackingEvents();
  }

  addTrackingEvents(): void {
    this.eventLogger.cleverTapEvent('popUpView', JSON.stringify({ name: 'multi-product-selection-popup', pageName: 'multi-product-selection' }),
      [
      this.appConfig.Shared.EventTracker.CLEVER_TAP,
      this.appConfig.Shared.EventTracker.MOENGAGE,
      this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
      ]);
  }

  isProductSelected(productId: string): boolean {
    return this.selectedProducts.includes(productId);
  }


  onProductChecked(productId: string, event: Event): void {
    const input = event.target as HTMLInputElement | null;
    const checked = !!input?.checked;

    if (checked) {
      if (!this.selectedProducts.includes(productId)) {
        this.selectedProducts = [...this.selectedProducts, productId];
      }
    } else {
      this.selectedProducts = this.selectedProducts.filter(id => id !== productId);
    }
  }

  async openNativePopup(): Promise<void> {
    const matchingProducts = this.data.content.filter((product: any): boolean =>
      this.selectedProducts.includes(product.objectId),
    );

    this.eventLogger.cleverTapEvent(
      'click',
      JSON.stringify({ name: 'multi-product-selection-popup-continue' }),
    );

    const json = {
      type: 'multi_option_multi_select',
      clickOnYes: true,
      options: matchingProducts,
    };

    if (this.data?.callback) this.data.callback(json);
    this.bottomSheetRef.dismiss();
  }

  closedPopup(): void {
    this.eventLogger.cleverTapEvent(
      'click',
      JSON.stringify({ name: 'multi-product-selection-popup-closed' }),
      [
        this.appConfig.Shared.EventTracker.CLEVER_TAP,
        this.appConfig.Shared.EventTracker.MOENGAGE,
        this.appConfig.Shared.EventTracker.CURESKIN_METRICS,
      ],
    );
    this.bottomSheetRef.dismiss();
  }
}
